import { Button } from '@material-ui/core';
import styled from 'styled-components';

// Função auxiliar para escurecer a cor no hover
function darken(color, percent) {
  try {
    const num = parseInt(color.replace('#', ''), 16);
    const amt = Math.round(2.55 * percent * 100);
    const R = (num >> 16) - amt;
    const G = ((num >> 8) & 0x00ff) - amt;
    const B = (num & 0x0000ff) - amt;
    return `#${(
      0x1000000 +
      (R < 255 ? (R < 0 ? 0 : R) : 255) * 0x10000 +
      (G < 255 ? (G < 0 ? 0 : G) : 255) * 0x100 +
      (B < 255 ? (B < 0 ? 0 : B) : 255)
    )
      .toString(16)
      .slice(1)}`;
  } catch {
    return color;
  }
}

export const StyledButton = styled(Button)`
  && {
    background-color: ${(props) => props.$bg};
    color: ${(props) => props.$color};
    text-transform: none;
    justify-content: flex-start;

    &:hover {
      background-color: ${(props) => darken(props.$bg, 0.1)};
    }

    &:disabled {
      opacity: 0.7;
    }
  }
`;
